<template>
  <component
    v-if="layout !== null"
    id="app"
    :is="layout"
  >
    <router-view />
  </component>
  <router-view v-else />
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

const defaultLayout = 'default';

export default {
  computed: {
    layout() {
      if (this.$route.meta.noLayout) {
        return null;
      }
      return `${this.$route.meta.layout || defaultLayout}-layout`;
    },
  },
};
</script>

<style lang="scss">
  html, body {
    -webkit-font-smoothing: antialiased;
    font-family: Roboto;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: Ubuntu;
  }

  .user-select-none{
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
</style>
